import { render, staticRenderFns } from "./Ability.vue?vue&type=template&id=a3fb44be&scoped=true"
import script from "./Ability.vue?vue&type=script&lang=js"
export * from "./Ability.vue?vue&type=script&lang=js"
import style0 from "./Ability.vue?vue&type=style&index=0&id=a3fb44be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fb44be",
  null
  
)

export default component.exports